import { render, staticRenderFns } from "./OwnerDetail.vue?vue&type=template&id=6e1a6707&scoped=true"
import script from "./OwnerDetail.vue?vue&type=script&lang=js"
export * from "./OwnerDetail.vue?vue&type=script&lang=js"
import style0 from "./OwnerDetail.vue?vue&type=style&index=0&id=6e1a6707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1a6707",
  null
  
)

export default component.exports